// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';
import {mapFormValidation} from '../services/claim-validation-helper';
import {readLaborTypes} from '../../shared/action-creators/labor-types';
import {validAmountOfUse} from '../../shared/services/claim-shared-helper';

export const updateResponsibleAccountsDropDown = (accountId, dealerCollection, pin) =>

    dispatch => {

        dispatch({
            accountId,
            dealerCollection,
            type: actions.UPDATE_CLAIM_SPA_RESPONSIBLE_ACCOUNTS
        });

        if (accountId) {

            readLaborTypes(accountId, pin)(dispatch);

        }

    };

export const updateSpaClaimPin = pin =>

    dispatch => {

        dispatch({
            property: 'pin',
            type: actions.UPDATE_CLAIM_SPA_PROPERTY,
            value: pin
        });

        if (pin === '') {

            dispatch({
                property: 'useAmount',
                type: actions.UPDATE_CLAIM_SPA_FORM_VALIDATION,
                validity: true
            });

        }

    };

export const updateSpaClaimProperty = (property, value) => ({
    property,
    type: actions.UPDATE_CLAIM_SPA_PROPERTY,
    value
});

export const updateSpaClaimCalculationProperty = (property, value) => ({
    property,
    type: actions.UPDATE_CLAIM_SPA_CALCULATION_PROPERTY,
    value
});

export const updateSpaClaimWorkOrderOne = workOrder => ({
    type: actions.UPDATE_CLAIM_SPA_WORK_ORDER_ONE,
    workOrder
});

export const updateSpaClaimWorkOrderTwo = workOrder => ({
    type: actions.UPDATE_CLAIM_SPA_WORK_ORDER_TWO,
    workOrder
});

export const updateSpaClaimType = (spaType, collection) =>

    dispatch => {

        dispatch({
            collection,
            spaType,
            type: actions.UPDATE_CLAIM_SPA_TYPE
        });

        dispatch({
            property: 'retailInstallDate',
            type: actions.UPDATE_CLAIM_SPA_FORM_VALIDATION,
            validity: true
        });

    };

export const updateSpaClaimRepairNumber = repairNumber => ({
    repairNumber,
    type: actions.UPDATE_CLAIM_SPA_REPAIR_NUMBER
});

export const updateOwnershipStatusDropDown = (key, statusCollection) => ({
    key,
    statusCollection,
    type: actions.UPDATE_CLAIM_SPA_OWNERSHIP_STATUS
});

export const updateSpaClaimFailurePart = partNumber => ({
    partNumber,
    type: actions.UPDATE_CLAIM_SPA_FAILURE_PART
});

export const updateSpaClaimFailureDate = failureDate => ({
    failureDate,
    type: actions.UPDATE_CLAIM_SPA_FAILURE_DATE
});

export const updateSpaClaimRepairDate = repairDate => ({
    repairDate,
    type: actions.UPDATE_CLAIM_SPA_REPAIR_DATE
});

export const updateSpaClaimUnitDropDown = (key, unitCollection) => ({
    key,
    type: actions.UPDATE_CLAIM_SPA_USE_AMOUNT_UNIT,
    unitCollection
});

export const updateSpaClaimUseAmount = amount => ({
    amount: validAmountOfUse(amount),
    type: actions.UPDATE_CLAIM_SPA_USE_AMOUNT
});

export const updateSpaClaimInputOnBlur = (property, value, claim) => ({
    property,
    type: actions.UPDATE_CLAIM_SPA_FORM_VALIDATION,
    validity: mapFormValidation(property, value, claim)
});

export const resetSpaClaim = () => ({
    type: actions.RESET_CLAIM_SPA
});

export const resetSpaProductDetails = () => ({
    type: actions.RESET_CLAIM_SPA_PRODUCT_DETAILS
});

export const resetSpaFieldsForUptimeClaim = () => ({
    type: actions.RESET_CLAIM_SPA_DETAILS_FOR_UPTIME
});

export const updateStickyHeaderVisibility = status =>

    dispatch => {

        const STICKY_STATUS_FIXED = 2;

        dispatch({
            isVisible: status === STICKY_STATUS_FIXED,
            type: actions.UPDATE_CLAIM_SPA_STICKY_HEADER_VISIBILITY
        });

    };



// WEBPACK FOOTER //
// ./src/claim/spa/action-creators/claim-details.js